import { HeaderVariant } from '../types';

// The fixed header reserves space with a sibling spacer div sized to the header's
// real height. The black announcement bar (h-10 = 40px) only renders on the
// navigation variant and only when the merchant hasn't hidden it via `visibleBar`;
// when it's absent the spacer must drop by that 40px so the page content below
// moves up to fill the gap (EWM-340 AC: "all other components move up"). The pairs
// differ by exactly 40px: 168→128 (mobile), 160→120 (desktop).
export const getHeaderSpacerHeight = (variant: HeaderVariant, visibleBar?: boolean): string =>
  variant === 'navigation' && (visibleBar ?? true) ? 'h-[168px] lg:h-[160px]' : 'h-[128px] lg:h-[120px]';

// The header's real height on mobile (matching getHeaderSpacerHeight's mobile
// values). Used as the hide-on-scroll offset so the header only starts hiding
// once its spacer has scrolled out of view (EWM-551 — avoids a white gap).
export const getHeaderMobileHeight = (variant: HeaderVariant, visibleBar?: boolean): number =>
  variant === 'navigation' && (visibleBar ?? true) ? 168 : 128;
